import { useState } from 'react';
import type { LigneVivier } from '../partage/api/types';
import { LigneAttente } from './LigneAttente';
import { A_VERIFIER, REPLIER, VOIR } from '../partage/vocabulaire';
import './PapiersDeMaintenant.css';

/**
 * « À vérifier », un post-it jaune punaisé en haut de la colonne de droite (chantier
 * maintenant-en-etages, modification 01 ; maquette du carnet `maintenant.html`, `.pi.jaune.verif`) :
 * une phrase (« 2 réponses attendues. La prochaine demain : « Décrire mes clients ». »), et
 * « Voir › » qui déplie les attentes, chacune avec son dessin, « C'est arrivé » et « Relancer ».
 * Sans attente, le post-it le dit, sans « Voir ».
 */
export function BandeAVerifier({
  lignes,
  phrase,
  aujourdhui,
  onOuvrir,
  onArrive,
  onRelancer,
}: {
  lignes: LigneVivier[];
  phrase: string;
  /** Le jour de l'utilisateur, celui que compte la jauge de chaque attente. */
  aujourdhui: string;
  onOuvrir: (id: string) => void;
  onArrive: (id: string) => void;
  onRelancer: (id: string) => void;
}) {
  const [ouvert, setOuvert] = useState(false);
  const vide = lignes.length === 0;

  return (
    <section className="papier-de-maintenant a-verifier" aria-label={A_VERIFIER} data-tuto="groupe-a-verifier">
      <span className="papier-de-maintenant-punaise" aria-hidden="true" />
      <p className="papier-de-maintenant-titre">{A_VERIFIER}</p>
      <p className="papier-de-maintenant-main">{phrase}</p>
      {!vide && (
        <button type="button" className="a-verifier-voir" aria-expanded={ouvert} onClick={() => setOuvert(!ouvert)}>
          {ouvert ? REPLIER : VOIR} ›
        </button>
      )}
      {ouvert && !vide && (
        <ul className="a-verifier-lignes">
          {lignes.map((l) => (
            <li key={l.id}>
              <LigneAttente ligne={l} aujourdhui={aujourdhui} onOuvrir={onOuvrir} onArrive={onArrive} onRelancer={onRelancer} />
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
